<template>
    <NuxtLayout name="default" mainClass="inside_main">
      <div class="landing_wrapper business">
        <div class="container">
          <div class="hero experts">
            <div class="row align-items-center">
              <div class="col-md-6">
                <div class="section_title text-right">
                  <h1>انضم لبرنامج "الخبراء" وابدأ تحقيق الأرباح من تقييماتك</h1>
                </div>
                <div class="sub_title text-right">
                  <h3>ساعد الآخرين في اتخاذ قرارات صحيحة من خلال خبرتك</h3>
                </div>

              </div>
              <div class="col-md-6">
                <div class="image">
                    <img src="/website/assets/img/business/expert-hero.png" alt="">
                </div>
              </div>
            </div>
            
          

          </div>



          <br>
            <br>
            <br>

            <div class="info_list" id="features">

                <h3>مزايا العمل مع رفيو :</h3>

                <ul>
                    <li>
                        اﻻﻧﻀﻤﺎم للبرنامج ﻣﺠﺎﻧﻲ ﻷي ﺷﺨﺺ وﻻ ﻳﺘﻄﻠﺐ ﺷﺮوط.

                    </li>
                    <li>
                        ﺳﻴﺘﻮﻓﺮ ﻟﻚ ﺣﺴﺎب ﺧﺎص ﻟﻤﺘﺎﺑﻌﺔ أداﺋﻚ وﻣﻌﺮﻓﺔ اﺣﺼﺎﺋﻴﺎت ﺣﻮل ﺗﻘﻴﻴﻤﺎﺗﻚ.

                    </li>
                    <li>
                        دﻋﻢ ﻣﺒﺎﺷﺮ ﻟﻜﻴﻔﻴﺔ اﻟﻌﻤﻞ وﺗﻮﻓﻴﺮ ﻣﻮاد ﺗﻌﻠﻴﻤﻴﺔ ﻟﺘﺤﺴﻴﻦ اﻷداء.

                    </li>
                    <li>
                        ﻣﻌﺮﻓﺔ رﺻﻴﺪ أرﺑﺎﺣﻚ و إﻣﻜﺎﻧﻴﺔ ﻃﻠﺐ ﺳﺤﺐ اﻟﺮﺻﻴﺪ ﻟﺤﺴﺎﺑﻚ اﻟﺨﺎص ﻣﺒﺎﺷﺮة ﻋﻦ ﻃﺮﻳﻖ ﺣﻮاﻟﺔ ﺑﻨﻜﻴﺔ.

                    </li>
                    <li>
                        اﻟﺤﺼﻮل ﻋﻠﻰ ﻫﺪاﻳﺎ و ﻣﻜﺎﻓﺌﺎت ﺧﺎﺻﺔ ﻣﺮﺗﺒﻄﺔ ﺑﺎﻷداء (ﻛﻮﺑﻮﻧﺎت ﺗﺴﻮق ﻣﻦ ﻣﺘﺎﺟﺮ ﻣﺤﻠﻴﺔ ﻛﺒﻴﺮة).
                    </li>
                </ul>

            </div>

            <div class="info_list">

                <h3>طريقة الانضمام : </h3>

                <ul>
                    <li>
                        التسجيل في نموذج الخبراء وتقديم البيانات المطلوبة بالأسفل .

                    </li>
                    <li>
                        ﻣﺮاﺟﻌﺔ ﻃﻠﺐ اﻧﻀﻤﺎﻣﻚ ﻣﻦ ﻗﺒﻞ ﻓﺮﻳﻖ ﺛﻘﺔ.


                    </li>
                    <li>
                        اﺷﻌﺎرك ﺑﺎﻟﻘﺒﻮل و اﻻﻧﺘﻘﺎل ﻟﻠﺨﻄﻮة اﻟﺘﺎﻟﻴﺔ أو اﻟﺮﻓﺾ ﻣﻊ ﺗﻮﺿﻴﺢ اﻟﺴﺒﺐ.


                    </li>
                    <li>
                        اﺟﺘﻴﺎز اﻟﺪورة اﻟﺘﺪرﻳﺒﻴﺔ اﻟﺘﻌﻠﻴﻤﻴﺔ ﻟﻜﻴﻔﻴﺔ اﻟﻌﻤﻞ و اﻟﺘﺤﻘﻖ ﻣﻦ اﻟﺠﺎﻫﺰﻳﺔ.


                    </li>
                    <li>
                        ﺗﻔﻌﻴﻞ اﻟﺤﺴﺎب و اﻟﺒﺪء ﺑﺎﻟﻌﻤﻞ.
                    </li>
                    <li>
                        اﻟﻤﺘﺎﺑﻌﺔ و اﻟﺪﻋﻢ و اﻻرﺷﺎد ﻟﻠﺘﺤﺴﻴﻦ اﻟﻤﺴﺘﻤﺮ.

                    </li>
                </ul>

            </div>


  
          <div class="contact-form">
            <div class="row align-items-center">
              <div class="col-12">
                <div class="section_title">
                  <h1>انضم الآن</h1>
                </div>
              </div>
            </div>
  
            <div class="contact-form-inputs">
              <form @submit.prevent="handleSubmit">
                <div class="row">
                  <div class="col-md-6">
                    <div class="input-group">
                      <input name="first_name" v-model="form.first_name" type="text" placeholder="الاسم كامل" class="form-control input-v-m" />
                      <span class="has-error text-danger w-100">{{ errors.first_name }}</span>
                    </div>
                  </div>
  
                  <div class="col-md-6">
                    <div class="input-group">
                      <input name="mobile" v-model="form.mobile" type="tel" placeholder="512345678" class="form-control mobile input-v-m" maxlength="10" />
                      <span class="has-error text-danger w-100">{{ errors.mobile }}</span>
                      <div class="country_code">
                        <img src="/website/assets/img/SaudiArabiaFlag.png" alt="SaudiArabiaFlag" />
                        <span>+966</span>
                      </div>
                    </div>
                  </div>
  
                  <div class="col-md-6">
                    <div class="input-group">
                      <input name="email" v-model="form.email" type="email" placeholder="البريد الالكتروني" class="form-control input-v-m" />
                      <span class="has-error text-danger w-100">{{ errors.email }}</span>
                    </div>
                  </div>
  
                  <div class="col-md-6">
                    <div class="input-group">
                      <!-- <select v-model="form.age" class="form-control input-v-m">
                        <option value="" disabled selected>العمر</option>
                        <option v-for="n in 80" :key="n" :value="n">{{ n }}</option>
                      </select> -->
                      <input v-model="form.age" type="text" placeholder="العمر" class="form-control input-v-m" />
                      <span class="has-error text-danger w-100">{{ errors.age }}</span>
                    </div>
                  </div>
  
                  <div class="col-md-6">
                    <div class="input-group">
                      <select v-model="form.gender" class="form-control input-v-m">
                        <option value="" disabled selected>الجنس</option>
                        <option value="1">ذكر</option>
                        <option value="2">أنثى</option>
                      </select>
                      <span class="has-error text-danger w-100">{{ errors.gender }}</span>
                    </div>
                  </div>
  
                  <div class="col-md-6">
                    <div class="input-group">
                      <select v-model="form.city_id" class="form-control input-v-m">
                        <option value="" disabled selected>المدينة</option>
                        <option v-for="city in cities" :key="city.id" :value="city.id">
                          {{ city.name }}
                        </option>
                      </select>
                      <span class="has-error text-danger w-100">{{ errors.city_id }}</span>
                    </div>
                  </div>
  
                  <!-- Only a single category field is used -->
                  <div class="col-md-6">
                    <div class="input-group">
                      <select v-model="form.mainCategoryId" class="form-control input-v-m">
                        <option value="" disabled selected>المجال الذي لديك خبرة فيه</option>
                        <option v-for="category in mainCategories" :key="category.id" :value="category.id">
                          {{ category.name }}
                        </option>
                      </select>
                      <span class="has-error text-danger w-100">{{ errors.mainCategoryId }}</span>
                    </div>
                  </div>
  
                  <div class="col-md-6">
                    <div class="input-group">
                      <input name="googleUrl" v-model="form.googleUrl" type="text" placeholder="رابط حسابك في خرائط جوجل" class="form-control input-v-m" />
                      <span class="has-error text-danger w-100">{{ errors.googleUrl }}</span>
                    </div>
                  </div>
  
                  <div class="col-md-12">
                    <div class="input-group">
                      <textarea name="expert_details" v-model="form.expert_details" placeholder="نبذة عن خبراتك السابقة في التقييم" class="form-control input-v-m" rows="6"></textarea>
                      <span class="has-error text-danger w-100">{{ errors.expert_details }}</span>
                    </div>
                  </div>
  
                  <div class="col-md-12">
                    <div class="input-group mb-0">
                      <button type="submit" class="form-control has-spinner-link" :disabled="isLoading">
                        <div class="button_text">
                          {{ isLoading ? 'جاري الإرسال...' : 'إرسال' }}
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </NuxtLayout>
  </template>
  
  <script setup lang="ts">
  import { ref, reactive, onMounted } from 'vue'
  import { useHead } from '#imports'
  import Swal from 'sweetalert2'
  import { formsRepository } from '~/utils/formsRepository'
  import { websiteRepository } from '~/utils/websiteRepository'
  
  const { $api } = useNuxtApp()
  const websiteRepo = websiteRepository($api)
  const { showAlert } = useGlobalAlert()
  
  useHead({
    title: 'برنامج الخبراء',
    meta: [
      { property: 'og:title', content: 'برنامج الخبراء | رفيو المنصة الأولى في التقييم و معرفة تجارب الآخرين و الاستفادة منها' },
      { property: 'twitter:title', content: 'برنامج الخبراء | رفيو المنصة الأولى في التقييم و معرفة تجارب الآخرين و الاستفادة منها' }
    ]
  })
  
  // Form state
  const form = reactive({
    first_name: '',
    mobile: '',
    email: '',
    age: '',
    gender: '',
    city_id: '',
    mainCategoryId: '',
    googleUrl: '',
    expert_details: ''
  })
  
  const errors = reactive({
    first_name: '',
    mobile: '',
    email: '',
    age: '',
    gender: '',
    city_id: '',
    mainCategoryId: '',
    googleUrl: '',
    expert_details: ''
  })
  
  const isLoading = ref(false)
  
  // Sample expert categories (replace with an API call if needed)
  const mainCategories = ref<{ id: number; name: string }[]>([])

  const categoriesRepo = categoriesRepository($api)
  async function fetchMainCategories() {
    try {
      const response = await categoriesRepo.get()
      mainCategories.value = response || []
    } catch (error) {
      console.error('Error fetching main categories:', error)
    }
  }
  
  // Cities list – to be fetched from the API
  const cities = ref<{ id: number; name: string }[]>([])
  
  // Function to fetch cities using websiteRepository (similar to sections)
  async function fetchCities() {
    try {
      // Assuming the API endpoint for cities is '/cities'
      const response = await websiteRepo.getCities() // You need to add this method to the repository
      if (response.status) {
        cities.value = response.data
      }
    } catch (error) {
      console.error('Error fetching cities:', error)
    }
  }
  

    /**
   * Normalize the mobile number:
   * - If the number has 10 digits and starts with "05", remove the leading "0"
   * - Otherwise, return the number as-is.
   */
   const normalizeMobileNumber = (num: string): string => {
    num = num.trim();
    if (num.length === 10 && num.startsWith("05")) {
      return num.slice(1);
    }
    return num;
  };

  /**
   * Validate the mobile number.
   * - If the normalized number has 9 digits and starts with "5", it is valid.
   * - Otherwise, set an appropriate error message.
   */
  const validateMobile = () => {
    const normalized = normalizeMobileNumber(form.mobile);
    if (normalized.length === 9 && normalized.startsWith("5")) {
      errors.mobile = "";
    } else {
      errors.mobile =
        "إدخل رقم جوال صحيح ، يبدأ الرقم بـ 5 او 05";
        return false;
    }

    return true;
  };

  // Form validation
  function validateForm(): boolean {
    let valid = true
    // Reset errors
    Object.keys(errors).forEach((key) => (errors[key] = ''))
    
    if (!form.first_name.trim()) {
      errors.first_name = 'الاسم كامل مطلوب'
      valid = false
    }
    if (!form.mobile.trim()) {
      errors.mobile = 'رقم الهاتف مطلوب'
      valid = false
    }
    
    valid = validateMobile();

    if (!form.email.trim()) {
      errors.email = 'البريد الالكتروني مطلوب'
      valid = false
    }
    if (!form.age) {
      errors.age = 'العمر مطلوب'
      valid = false
    }
    if (!form.gender) {
      errors.gender = 'الجنس مطلوب'
      valid = false
    }
    if (!form.city_id) {
      errors.city_id = 'المدينة مطلوبة'
      valid = false
    }
    if (!form.mainCategoryId) {
      errors.mainCategoryId = 'المجال مطلوب'
      valid = false
    }
    if (!form.googleUrl.trim()) {
      errors.googleUrl = 'رابط حساب خرائط جوجل مطلوب'
      valid = false
    }
    if (!form.expert_details.trim()) {
      errors.expert_details = 'نبذة الخبرات مطلوبة'
      valid = false
    }
    return valid
  }
  
  const formRepo = formsRepository()
  
  async function handleSubmit() {
    isLoading.value = true
    if (!validateForm()) {
      isLoading.value = false
      return
    }


  
    const formData = new FormData()
    formData.append('name', form.first_name)
    formData.append('phone_number', normalizeMobileNumber(form.mobile))
    formData.append('email', form.email)
    formData.append('age', form.age)
    formData.append('gender', form.gender)
    formData.append('city_id', form.city_id)
    formData.append('place_category_id', form.mainCategoryId)
    formData.append('google_url', form.googleUrl)
    formData.append('description', form.expert_details)
  
    try {
      const response = await formRepo.joinExpert(formData)
      if (response.response.status === true) {

        showAlert('تم إرسال الطلب بنجاح', 'success')
        // Reset form fields
        // first_name.value = ''
        // mobile.value = ''
        // email.value = ''
        // age.value = ''
        // gender.value = ''
        // mainCategoryId.value = ''
        // googleUrl.value = ''
        // expert_details.value = ''
        // Reset form fields
        Object.keys(form).forEach(key => form[key] = '')
      } else {
        
        Swal.fire({ icon: 'error', title: response.response?.message || 'حدث خطأ ما، يرجى المحاولة مرة أخرى', timer: 2000, showConfirmButton: false })
      }
    } catch (error) {
        if (error.response._data && error.response._data && error.response._data.errors) {
            const apiErrors = error.response._data.errors
            

            errors.first_name = apiErrors?.find(error => error.key === "name") ? apiErrors?.find(error => error.key === "name").value : ''
            errors.mobile = apiErrors?.find(error => error.key === "phone_number") ? apiErrors?.find(error => error.key === "phone_number").value : ''
            errors.email = apiErrors?.find(error => error.key === "email") ? apiErrors?.find(error => error.key === "email").value : ''
            errors.age = apiErrors?.find(error => error.key === "age") ? apiErrors?.find(error => error.key === "age").value : ''
            errors.gender = apiErrors?.find(error => error.key === "gender") ? apiErrors?.find(error => error.key === "gender").value : ''
            errors.city_id = apiErrors?.find(error => error.key === "city_id") ? apiErrors?.find(error => error.key === "city_id").value : ''
            errors.mainCategoryId = apiErrors?.find(error => error.key === "place_category_id") ? apiErrors?.find(error => error.key === "place_category_id").value : ''
            errors.googleUrl = apiErrors?.find(error => error.key === "google_url") ? apiErrors?.find(error => error.key === "google_url").value : ''
            errors.expert_details = apiErrors?.find(error => error.key === "description") ? apiErrors?.find(error => error.key === "description").value : ''
        }



      Swal.fire({ icon: 'error', title: 'حدث خطأ ما، يرجى المحاولة مرة أخرى', timer: 2000, showConfirmButton: false })
      console.error('Form submission error:', error)
    } finally {
      isLoading.value = false
    }
  }
  
  onMounted(() => {
    fetchCities()
    fetchMainCategories();
  })
  </script>
  
  <style scoped>
  @import url("~/assets/css/landingStyles.css");
  </style>
  